import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig, ENV_CONFIG } from 'src/app/core/enviroment-config';
import { CrudApiService } from 'src/app/core/service/abstract/rest-api.service';
import { Waypoint } from 'src/app/data/model/waypoints';
import { ApiModule } from '../api.module';

@Injectable({
  providedIn: ApiModule,
})
export class OdsWaypointsApiService extends CrudApiService<Waypoint> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('resources/ods-waypoints', http, config);
  }
}

